import React from 'react';
import debounce from '../node_modules/lodash-es/debounce.js';

const useDebouncedCallback = (fn, delay = 200) => {
  return React.useMemo(() => {
    if (fn && delay) {
      return debounce(fn, delay);
    }
    return fn;
  }, [
    delay,
    fn
  ]);
};

export { useDebouncedCallback };
//# sourceMappingURL=useDebouncedCallback.js.map
